import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const LIQUIDITY_FORM_NAMES = {
  LIQUIDITY_VARIANTS: 'liquidityVariants',
  LIQUIDITY_TABLE: 'liquidityTable',
  ANTICIPATED_OUTCOME: 'anticipatedOutcome',
} as const;

export const liquidityVariants = ['Current Ratio', 'Quick Ratio'];

//  ---- COMMON ----
export interface ILiquidityFormValuesType {
  [LIQUIDITY_FORM_NAMES.LIQUIDITY_VARIANTS]: string[];
  [LIQUIDITY_FORM_NAMES.LIQUIDITY_TABLE]: IPeriodsTableRow[];
  [LIQUIDITY_FORM_NAMES.ANTICIPATED_OUTCOME]: string;
}

export const liquidityInitialValues = {
  [LIQUIDITY_FORM_NAMES.LIQUIDITY_VARIANTS]: liquidityVariants,
  [LIQUIDITY_FORM_NAMES.LIQUIDITY_TABLE]: getFormTableInitialValues2(liquidityVariants.length, initialPeriodsTableRow),
  [LIQUIDITY_FORM_NAMES.ANTICIPATED_OUTCOME]: '',
};
